import { createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d8615df")

_pushScopeId("data-v-5d8615df")
const _hoisted_1 = { class: "account-verify-modal-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "account-verify-modal-header" }, null, -1)
const _hoisted_3 = { class: "account-verify-modal-content" }
const _hoisted_4 = { class: "account-verify-modal-content-icon" }
const _hoisted_5 = { class: "account-verify-modal-content-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HModal = _resolveComponent("HModal")!

  return (_openBlock(), _createBlock(_component_HModal, {
    visible: _ctx.props.visible,
    showClose: false,
    class: "account-verify-modal"
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", {
          class: "close-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }),
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", {
              class: ["logo-img", _ctx.props.type === 'success' ? 'success-icon' : 'warn-icon']
            }, null, 2)
          ]),
          _createVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ])
      ])
    ]),
    _: 3
  }, 8, ["visible"]))
})